import React from 'react';
import { Jumbotron as Jumbo, Container } from 'react-bootstrap';
import styled from 'styled-components';
import {Layout} from './components/Layout';
import {Jumbotron} from './components/Jumbotron3';

const Styles=styled.div`

@media only screen and (max-width: 1000px) {

.gif{
width:100%;
height:101%;
}
.text{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;

}
.title{
font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:40px;
margin-left:90px;
padding-top:40px;
float:center;
}
.psd2{
width:95%;
margin-top:30px;
margin-bottom:3px;
margin-left:15px
margin-right:15px
border: 2px solid black;
}
.text1{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;0
margin-top:40px;
margin-right:15px;
}
.email{
width:95%;
margin-top:30px;
margin-bottom:3px;
margin-left:15px
margin-right:15px
border: 2px solid black;
}
.text2{
margin-left:10px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;
margin-bottom:150px;
margin-left:15px;
}
}

@media only screen and (min-width: 1001px) {
.gif{
width:50%;
border: 2px solid black;
margin-bottom:50px;
margin-right:auto;
margin-left:400px;
}

.text{
margin-left:200px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-right:200px;
}

.text1{
font-family: 'Open Sans', sans-serif;
margin-right:900px;
margin-left:90px;
margin-top:100px;
margin-bottom:100px;
font-size:24px;
}

.psd2{
float:right;
width:50%;
margin-top:-90px;
margin-right:40px;
border: 2px solid black;

}
.email{
float:left;
width:45%;
margin-top:100px;
margin-right:100px;
margin-left:50px;
margin-bottom:200px;
border: 2px solid black;

}

.title{
font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:200px;
margin-left:90px;

}
.text2{
font-family: 'Open Sans', sans-serif;
margin-top:600px;
text-align:left;
font-size:24px;
margin-right:30px;
margin-left:200px;
marting-top:20px;

}

}

;`

export const PaymentsProducts = () => (
<React.Fragment>
	<Jumbotron />
	<Styles>
	<body>

	<div class="text">
	<p>In 2019, I joined Hilton's digital products organization on the payments team. My main focus was to guide Hilton through Europe's PSD2 e-commerce regulation. PSD2 seeks to make payments more secure in Europe, by introducing two-factor authentication for online purchases.</p>
	
	</div>
	<img src={require('./assets/psd2.gif')} alt="PSD2Gif" Class="gif"/> 	
		<div class="text">
		<p Style="font-size:13px;margin-top:5px;text-align:right;"><a href="https://www.finextra.com/blogposting/12932/psd2-explained-in-3-simple-gifs"target="_blank"> GIF provided by Finextra </a></p>
			</div>
	<div class="text">
	<p>My role on the payments team: I provided product vision and strategy, UX/design/copy direction, user engagement/feedback, backlog prioritization, and QA.</p>
</div>

	<div className="title">
	<p> PSD2 </p>
	</div>
<img src={require('./assets/psd2tool.png')} alt="PSD2 Payment Tool" Class="psd2" /> 
		  <div className="text1">
		  	<p> Our MVP solution for PSD2: we created a hotel-facing web app that would generate payment links.</p>
			
			<p> The hotels would generate the payment request, and send the payment links to the guest via e-mail. </p>
		  </div>
		  		  <img src={require('./assets/email.png')} alt="PSD2 Email Template" Class="email" />

	<div className="text2">
			<p> There are times in life where data will set you free; we maintained a ~85% credit card approval rating in the EEA after the initial enforcement of PSD2!  </p>

</div>
</body>

</Styles>
</React.Fragment>
	)